export const rubros = [
		{
			"nombre": "01.- Normatividad",
			"icono": "Normatividad.png",
			"formatos": [
				{
					"nombre": "Marco Normativo",
					"xlsx": "f01",
					"html": "f01"
				}
			],
			// "url" : "https://movilidadytransporte.hidalgo.gob.mx/transparencia/htm/2019/a69_f01SEMOT.htm"
		}, 
		{
			"nombre": "02.- Estructura",
			"icono":"Estructura.png",
			"formatos": [
				{
					"nombre": "Estructura Orgánica",
					"xlsx": "f02_a",
					"html": "f02_a"
				},
				{
					"nombre": "Organigrama",
					"xlsx": "f02_b",
					"html": "f02_b"
				}
			]
		},
		{
			"nombre": "03.- Facultades",
			"icono":"Facultades.png",
			"formatos": [
				{
					"nombre": "Facultades",
					"xlsx": "f03",
					"html": "f03"
				}
			]
		},
		{
			"nombre": "04.- Programas Operativos Anuales",
			"icono":"ProgramasOperativosAnuales.png",
			"formatos": [
				{
					"nombre": "Metas y Objetivos",
					"xlsx": "f04",
					"html": "f04"
				}
			]
		},
		{
			"nombre": "05.- Indicadores de Interés",
			"icono":"IndicadoresInteres.png",
			"formatos": [
				{
					"nombre": "Indicadores de Interés",
					"xlsx": "f05",
					"html": "f05"
				}
			]
		},
		{
			"nombre": "06.- Matriz de Indicadores",
			"icono":"MatrizIndicadores.png",
			"formatos": [
				{
					"nombre": "Matriz de Indicadores",
					"xlsx": "f06",
					"html": "f06"
				}
			]
		},
		{
			"nombre": "07.- Directorio",
			"icono":"Directorio.png",
			"formatos": [
				{
					"nombre": "Directorio",
					"xlsx": "f07",
					"html": "f07"
				}
			]
		},
		{
			"nombre": "08.- Sueldos",
			"icono":"Sueldos.png",
			"url" : "https://oficialiamayor.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/8.%20Sueldos",
			"formatos": [
                {
                    "nombre": "Remuneraciones",
                    "xlsx": "f08",
                    "html": "f08",
                    "xlsx_liga": "https://oficialiamayor.hidalgo.gob.mx/Transparencia/xlsx/a69_f8OM.xlsx",
                    "htm_liga": "https://oficialiamayor.hidalgo.gob.mx/Transparencia/htm/a69_f8OM.htm"
                }
            ]
		},
		{
			"nombre": "09.- Viáticos",
			"icono":"Viaticos.png",
			//"url" : "https://oficialiamayor.hidalgo.gob.mx/transparencia/48rubros/Viaticos.html",
			"formatos": [
				{
					"nombre": "Viáticos",
					"xlsx": "f09",
					"html": "f09"
				}
			]	
		},
		{
			"nombre": "10.- Plazas",
			"icono":"Plazas.png",
			"url" : "https://oficialiamayor.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/10.%20Plazas",
			"formatos": [
				{
					"nombre": "Total de Personal de Base y Confianza",
					"xlsx": "f10_a",
					"html": "f10_a",
					"xlsx_liga": "https://oficialiamayor.hidalgo.gob.mx/transparencia/xlsx/2023/a69_f10_aOM.xlsx",
					"htm_liga": "https://oficialiamayor.hidalgo.gob.mx/transparencia/htm/2023/a69_f10_aOM.htm"

				},
				{
					"nombre": "Total de las Plazas de Base y Confianza",
					"xlsx": "f10_b",
					"html": "f10_b",
					"xlsx_liga": "https://oficialiamayor.hidalgo.gob.mx/transparencia/xlsx/2023/a69_f10_bOM.xlsx",
					"htm_liga": "https://oficialiamayor.hidalgo.gob.mx/transparencia/htm/2023/a69_f10_bOM.htm"

				}
			]	
		},
		{
			"nombre": "11.- Honorarios",
			"icono":"Honorarios.png",
			"formatos": [
				{
					"nombre": "Personal de Honorarios",
					"xlsx": "f11",
					"html": "f11"
				}
			]	
		},
		{
			"nombre": "12.- Declaraciones Públicas",
			"icono":"DeclaracionesPublicas.png",
			"url" : "https://s-contraloria.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/12.%20Declaraciones%20P%C3%BAblicas",
			"formatos": [
				{
					"nombre": "Declaraciones Patrimoniales",
					"xlsx": "f12",
					"html": "f12",
					"xlsx_liga": "https://s-contraloria.hidalgo.gob.mx/transparencia/xls/a69_f12_SC.xlsx",
					"htm_liga": "https://s-contraloria.hidalgo.gob.mx/transparencia/htm/a69_f12_SC.htm"
				}
			]	
		},
		{
			"nombre": "13.- Datos de Contacto de la Unidad",
			"icono":"DatosContactoUnidad.png",
			"url" : "https://s-contraloria.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/13.%20Datos%20de%20Contacto%20de%20la%20Unidad",
			"formatos": [
				{
					"nombre": "Domicilio de la Unidad de Transparencia",
					"xlsx": "f13",
					"html": "f13",
					"xlsx_liga": "https://s-contraloria.hidalgo.gob.mx/transparencia/xls/a69_f13_SC.xlsx",
					"htm_liga": "https://s-contraloria.hidalgo.gob.mx/transparencia/htm/a69_f13_SC.htm"
				}
			]
		},
		{
			"nombre": "14.- Convocatorias",
			"icono":"Convocatorias.png",
			"url" : "https://oficialiamayor.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/14.%20Convocatorias",
			"formatos": [
				{
					"nombre": "Convocatorias a Concursos para Cargos Públicos",
					"xlsx": "f14",
					"html": "f14",
					"xlsx_liga": "https://oficialiamayor.hidalgo.gob.mx/transparencia/xlsx/2023/a69_f14OM.xlsx",
					"htm_liga": "https://oficialiamayor.hidalgo.gob.mx/transparencia/htm/2023/a69_f14OM.htm"
				}
			]
		},
		{
			"nombre": "15.- Programas Sociales",
			"icono":"ProgramasSociales.png",
		    "url" : "https://sebiso.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/15%20-%20Programas%20Sociales",
			"formatos": [
				{
					"nombre": "Programas de Subsidio, Estimulo y Apoyo",
					"xlsx": "f15_a",
					"html": "f15_a",
					"xlsx_liga": "https://sebiso.hidalgo.gob.mx/Transparencia/xlsx/a69_f15_a_SEBISO.xlsx",
					"htm_liga": "https://sebiso.hidalgo.gob.mx/Transparencia/htm/a69_f15_a_SEBISO.htm"
				},
				{
					"nombre": "Padrón de beneficiarios",
					"xlsx": "f15_b",
					"html": "f15_b",
					"xlsx_liga": "https://sebiso.hidalgo.gob.mx/Transparencia/xlsx/a69_f15_b_SEBISO.xlsx",
					"htm_liga": "https://sebiso.hidalgo.gob.mx/Transparencia/htm/a69_f15_b_SEBISO.htm"
				}
			]
		},
		{
			"nombre": "16.- Relaciones Laborales",
			"icono":"RelacionesLaborales.png",
			"url" : "https://oficialiamayor.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/16.%20Relaciones%20Laborales",
			"formatos": [
				{
					"nombre": "Condiciones Generales de Trabajo",
					"xlsx": "f16_a",
					"html": "f16_a",
					"xlsx_liga": "https://oficialiamayor.hidalgo.gob.mx/transparencia/xlsx/2023/a69_f16_aOM.xlsx",
					"htm_liga": "https://oficialiamayor.hidalgo.gob.mx/transparencia/htm/2023/a69_f16_aOM.htm"
				},
				{
					"nombre": "Recursos Públicos",
					"xlsx": "f16_b",
					"html": "f16_b",
					"xlsx_liga": "https://oficialiamayor.hidalgo.gob.mx/transparencia/xlsx/2023/a69_f16_bOM.xlsx",
					"htm_liga": "https://oficialiamayor.hidalgo.gob.mx/Transparencia/htm/a69_f16_bOM.htm"
				}
			]
		},
		{
			"nombre": "17.- Información Curricular",
			"icono":"InformacionCurricular.png",
			"formatos": [
				{
					"nombre": "Información Curricular",
					"xlsx": "f17",
					"html": "f17"
				}
			]
		},
		{
			"nombre": "18.- Sanciones Administrativas",
			"icono":"SancionesAdministrativas.png",
			"url" : "https://s-contraloria.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/18.%20Sanciones%20Administrativas",
			"formatos": [
				{
					"nombre": "Servidores Públicos Sancionados",
					"xlsx": "f18",
					"html": "f18",
					"xlsx_liga": "https://s-contraloria.hidalgo.gob.mx/transparencia/htm/a69_f18_SC.htm",
					"htm_liga": "https://s-contraloria.hidalgo.gob.mx/transparencia/htm/a69_f18_SC.htm"
				}
			]	
		},
		{
			"nombre": "19.- Servicios",
			"icono":"Servicios.png",
			"formatos": [
				{
					"nombre": "Servicios",
					"xlsx": "f19",
					"html": "f19"
				}
			]
		},
		{
			"nombre": "20.- Trámites",
			"icono":"Tramites.png",
			"formatos": [
				{
					"nombre": "Trámites",
					"xlsx": "f20",
					"html": "f20"
				}
			]
		},
		{
			"nombre": "21.- Presupuesto e Informes Trimestrales",
			"icono":"PresupuestoInformesTrimestrales.png",
			"url" : "https://hacienda.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/21.Presupuesto%20e%20Informes%20Trimestrales",
			"formatos": [
				{
					"nombre": "Presupuesto Anual",
					"xlsx": "f21_a",
					"html": "f21_a",
					"xlsx_liga": "https://hacienda.hidalgo.gob.mx/files/transparencia/xlsx/2024/Primer%20Trimestre/a69_f21_a%20SH.xlsx",
					"htm_liga": "https://hacienda.hidalgo.gob.mx/files/transparencia/htm/2024/Primer%20Trimestre/a69_f21_a%20SH.htm"
				},
				{
					"nombre": "Gasto Trimestral",
					"xlsx": "f21_b",
					"html": "f21_b",
					"xlsx_liga": "https://hacienda.hidalgo.gob.mx/files/transparencia/xlsx/2024/Tercer%20Trimestre/a69_f21_b%20SH.xlsx",
					"htm_liga": "https://hacienda.hidalgo.gob.mx/files/transparencia/htm/2024/Tercer%20Trimestre/a69_f21_b%20SH.htm"
				},
				{
					"nombre": "Cuenta Pública",
					"xlsx": "f21_c",
					"html": "f21_c",
					"xlsx_liga": "https://hacienda.hidalgo.gob.mx/files/transparencia/xlsx/2024/Primer%20Trimestre/a69_f21_c%20SH.xlsx",
					"htm_liga": "https://hacienda.hidalgo.gob.mx/files/transparencia/htm/2024/Primer%20Trimestre/a69_f21_c%20SH.htm"
				}
			]
			
		},
		{
			"nombre": "22.- Deuda Pública",
			"icono":"DeudaPublica.png",
			"url" : "https://hacienda.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/22.Deuda%20P%C3%BAblica",
			"formatos": [
				{
					"nombre": "Deuda Pública",
					"xlsx": "f22",
					"html": "f22",
					"xlsx_liga": "https://s-finanzas.hidalgo.gob.mx/transparencia/xlsx/2023/Primer%20Trimestre/a69_f22SFP.xlsx",
					"htm_liga": "https://s-finanzas.hidalgo.gob.mx/transparencia/htm/2023/Primer%20Trimestre/a69_f22SFP.htm"
				}
			]
		},
		{
			"nombre": "23.- Comunicación Social y Publicidad",
			"icono":"ComunicacionSocialPublicidad.png",
			"formatos": [
				{
					"nombre": "Programa Anual de Comunicación Social",
					"xlsx": "f23_a",
					"html": "f23_a"
				},
				{
					"nombre": "Erogación de Recursos de Comunicación Social",
					"xlsx": "f23_b",
					"html": "f23_b"
				},
				{
					"nombre": "Tiempos Oficiales",
					"xlsx": "f23_c",
					"html": "f23_c",
					"xlsx_liga": "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/RadioTVH/dir1/FC/a69_f23_c_RTH.xlsx",
					"htm_liga": "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/RadioTVH/dir1/FC/a69_f23_c_RTH.htm"
				},
				/*{
					"nombre": "Información Relacionada a Tiempos Oficiales",
					"xlsx": "f23_d",
					"html": "f23_d",
					"xlsx_liga": "http://transparenciadocs.hidalgo.gob.mx/ENTIDADES/RadioTVH/dir1/2023/Transparencia/xlsx/a69_f23_d_RTVH.xlsx",
					"htm_liga": "http://transparenciadocs.hidalgo.gob.mx/ENTIDADES/RadioTVH/dir1/2023/Transparencia/htm/a69_f23_d_RTVH.htm"
				},*/
			]
		},
		{
			"nombre": "24.- Resultados de Auditorías",
			"icono":"ResultadosAuditorias.png",
			"url" : "https://s-contraloria.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/24.%20Resultados%20de%20Auditor%C3%Adas",
			"formatos": [
				{
					"nombre": "Auditorías",
					"xlsx": "f24",
					"html": "f24",
					"xlsx_liga": "https://s-contraloria.hidalgo.gob.mx/transparencia/xls/a69_f24_SC.xlsx",
					"htm_liga": "https://s-contraloria.hidalgo.gob.mx/transparencia/htm/a69_f24_SC.htm"
				}
			]
		},
		{
			"nombre": "25.- Dictámines de Estados Financiero ",
			"icono":"DictamenesFinancieros.png",
			"url" : "https://hacienda.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/25.Dict%C3%A1menes%20de%20Estados%20Financieros",
			"formatos": [
				{
					"nombre": "Estados Financieros",
					"xlsx": "f25",
					"html": "f25",
					"xlsx_liga" : "https://s-finanzas.hidalgo.gob.mx/transparencia/xlsx/2023/Primer%20Trimestre/a69_f25SFP.xlsx",
					"htm_liga" : "https://s-finanzas.hidalgo.gob.mx/transparencia/htm/2023/Primer%20Trimestre/a69_f25SFP.htm"

				}
			]
		},
		{
			"nombre": "26.- Asignación de Recursos Públicos a Personas",
			"icono":"AsignacionRecursosPublicosPersonas.png",
			"url" : "https://hacienda.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/26.Asignacion%20de%20Recursos%20Publicos%20a%20Personas",
			"formatos": [
				{
	
					"nombre": "Personas a Quienes se asignó Recursos Públcios",
					"xlsx": "f26",
					"html": "f26",
				/*{
					"xlsx_liga" : "https://oficialiamayor.hidalgo.gob.mx/transparencia/xlsx/2023/a69_f26OM.xlsx",
					"htm_liga" : "https://oficialiamayor.hidalgo.gob.mx/transparencia/htm/2023/a69_f26OM.htm"
				}*/
				}
			]
		},
		{
			"nombre": "27.- Concesiones",
			"icono":"Concesiones.png",
			"formatos": [
				{
					"nombre": "Concesiones, Contratos, Convenios, Permisos, Licencias y Autorizaciones",
					"xlsx": "f27",
					"html": "f27"
				}
			]
		},
		{
			"nombre": "28.- Licitaciones Públicas",
			"icono":"LicitacionesPublicas.png",
			"formatos": [
				/*{
					"nombre": "Procedimientos de Licitación Pública e Invitación a Cuando Menos Tres Personas",
					"xlsx": "f28_a",
					"html": "f28_a",
					"xlsx_liga" : "https://oficialiamayor.hidalgo.gob.mx/Transparencia/xlsx/28-LGT_Art_70_Fr_XXVIIIOM.xlsx",
                    "htm_liga" : "https://oficialiamayor.hidalgo.gob.mx/Transparencia/htm/28-LGT_Art_70_Fr_XXVIIIOM.htm"
				},*/
				{
					"nombre": "Procedimientos de Adjudicación Directa, Licitación Pública e Invitación Restringida",
					"xlsx": "f28",
					"html": "f28"
				}
			]
		},
		{
			"nombre": "29.- Informes",
			"icono":"Informes.png",
			"url" : "https://s-contraloria.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/29.%20Informes",
			"formatos": [
				{
					"nombre": "Informes",
					"xlsx": "f29",
					"html": "f29",
					"xlsx_liga" : "https://s-contraloria.hidalgo.gob.mx/transparencia/xls/a69_f29_SC.xlsx",
					"htm_liga" : "https://s-contraloria.hidalgo.gob.mx/transparencia/htm/a69_f29_SC.htm"
				}
			]
		},
		{
			"nombre": "30.- Estadísticas Generadas",
			"icono":"EstadisticasGenerales.png",
			"formatos": [
				{
					"nombre": "Estadísticas",
					"xlsx": "f30",
					"html": "f30"
				}
			]
		},
		{
			"nombre": "31.- Informe de Avances y Documentos Financiero",
			"icono":"InformeAvancesDocumentosFinancieros.png",
			"url" : "https://hacienda.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/31.Informe%20de%20Avances%20y%20Documentos%20Financieros",
			"formatos": [
				{
					"nombre": "Informe de Estados Financieros",
					"xlsx": "f31_a",
					"html": "f31_a",
					"xlsx_liga" : "https://s-finanzas.hidalgo.gob.mx/transparencia/xlsx/2023/Primer%20Trimestre/a69_f31_a%20SFP.xlsx",
					"htm_liga" : "https://s-finanzas.hidalgo.gob.mx/transparencia/htm/2023/Primer%20Trimestre/a69_f31_a%20SFP.htm"
				},
				{
					"nombre": "Informe Contable, Presupuestal y Programático",
					"xlsx": "f31_b",
					"html": "f31_b",
					"xlsx_liga" : "https://s-finanzas.hidalgo.gob.mx/transparencia/xlsx/2023/Primer%20Trimestre/a69_f31_b%20SFP.xlsx",
					"htm_liga" : "https://s-finanzas.hidalgo.gob.mx/transparencia/htm/2023/Primer%20Trimestre/a69_f31_b%20SFP.htm"
				}
			]
		},
		{
		    "nombre": "32.- Padrón de Proveedores y Contratistas",
			"icono":"PadronProveedoresContratistas.png",
			"url" : "https://s-contraloria.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/32.%20Padr%C3%B3n%20de%20Proveedores%20y%20Contratistas",
			"formatos": [
				{
					"nombre": "Padrón de Proveedores y Contratistas",
					"xlsx": "f32",
					"html": "f32",
					"xlsx_liga" : "https://s-contraloria.hidalgo.gob.mx/transparencia/xls/a69_f32_SC.xlsx",
					"htm_liga" : "https://s-contraloria.hidalgo.gob.mx/transparencia/htm/a69_f32_SC.htm"
				}
			]
		},
		{
			"nombre": "33.- Convenios con Sectores Social y Privado",
			"icono":"ConveniosSectoresSocialPrivado.png",
			"formatos": [
				{
					"nombre": "Convenios de Coordinación y Concertación",
					"xlsx": "f33",
					"html": "f33"
				}
			]
		},
		{
			"nombre": "34.- Inventario de Bienes",
			"icono":"InventarioBienes.png",
			"url" : "https://oficialiamayor.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/34.%20Inventario%20de%20Bienes",
			"formatos": [
				{
					"nombre": "Inventario de Bienes Muebles",
					"xlsx": "f34_a",
					"html": "f34_a",
					"xlsx_liga": "https://oficialiamayor.hidalgo.gob.mx/transparencia/xlsx/2023/a69_f34_aOM.xlsx",
					"htm_liga" : "https://oficialiamayor.hidalgo.gob.mx/transparencia/htm/2023/a69_f34_aOM.htm"
				},
				{
					"nombre": "Alta de Bienes Muebles",
					"xlsx": "f34_b",
					"html": "f34_b",
					"xlsx_liga": "https://oficialiamayor.hidalgo.gob.mx/transparencia/xlsx/2023/a69_f34_bOM.xlsx",
					"htm_liga" : "https://oficialiamayor.hidalgo.gob.mx/transparencia/htm/2023/a69_f34_bOM.htm"
				},
				{
					"nombre": "Bajas de Bienes Muebles",
					"xlsx": "f34_c",
					"html": "f34_c",
					"xlsx_liga": "https://oficialiamayor.hidalgo.gob.mx/transparencia/xlsx/2023/a69_f34_cOM.xlsx",
					"htm_liga" : "https://oficialiamayor.hidalgo.gob.mx/transparencia/htm/2023/a69_f34_cOM.htm"
				},
				{
					"nombre": "Inventario de Bienes Inmuebles",
					"xlsx": "f34_d",
					"html": "f34_d",
					"xlsx_liga": "https://oficialiamayor.hidalgo.gob.mx/transparencia/xlsx/2023/a69_f34_dOM.xlsx",
					"htm_liga" : "https://oficialiamayor.hidalgo.gob.mx/transparencia/htm/2023/a69_f34_dOM.htm"
				},
				{
					"nombre": "Alta de Bienes Inmuebles",
					"xlsx": "f34_e",
					"html": "f34_e",
					"xlsx_liga": "https://oficialiamayor.hidalgo.gob.mx/transparencia/xlsx/2023/a69_f34_eOM.xlsx",
					"htm_liga" : "https://oficialiamayor.hidalgo.gob.mx/transparencia/htm/2023/a69_f34_eOM.htm"

				},
				{
					"nombre": "Bajas de Bienes Inmuebles",
					"xlsx": "f34_f",
					"html": "f34_f",
					"xlsx_liga": "https://oficialiamayor.hidalgo.gob.mx/transparencia/xlsx/2023/a69_f34_fOM.xlsx",
					"htm_liga" : "https://oficialiamayor.hidalgo.gob.mx/transparencia/htm/2023/a69_f34_fOM.htm"
				},
				{
					"nombre": "Donaciones de Bienes Muebles e Inmuebles",
					"xlsx": "f34_g",
					"html": "f34_g",
					"xlsx_liga": "https://oficialiamayor.hidalgo.gob.mx/transparencia/xlsx/2023/a69_f34_gOM.xlsx",
					"htm_liga" : "https://oficialiamayor.hidalgo.gob.mx/transparencia/htm/2023/a69_f34_gOM.htm"
				}
			]
		},
		{
			"nombre": "35.- Recomendaciones y Atención en Materia de Derechos Humanos",
			"icono":"RecomendacionesAtenciónMateriaDerechosHumanos.png",
			"formatos": [
				{
					"nombre": "Recomendaciones de Derechos Humanos Emitidas por la CNDH",
					"xlsx": "f35_a",
					"html": "f35_a"
				},
				{
					"nombre": "Recomendaciones de Derechos Humanos Casos Especiales",
					"xlsx": "f35_b",
					"html": "f35_b"
				},
				{
					"nombre": "Las Recomendaciones de Derechos Humanos Org. Int. CNDH",
					"xlsx": "f35_c",
					"html": "f35_c"
				},
			]
		},
		{
			"nombre": "36.- Resoluciones y Laudos de Juicios",
			"icono":"ResolucionesLaudosJuicios.png",
			"url" : "https://s-contraloria.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/36.%20Resoluciones%20y%20Laudos%20de%20Juicios",
			"formatos": [
				{
					"nombre": "Resoluciones y Laudos ",
					"xlsx": "f36",
					"html": "f36",
					"xlsx_liga" : "https://s-contraloria.hidalgo.gob.mx/transparencia/xls/a69_f36_SC.xlsx",
					"htm_liga" : "https://s-contraloria.hidalgo.gob.mx/transparencia/htm/a69_f36_SC.htm"
				}
			]
		},
		{
			"nombre": "37.- Mecanismo de Participación Ciudadana",
			"icono":"MecanismosParticipacionCiudadana.png",
			"formatos": [
				{
					"nombre": "Mecanismos de Participación Ciudadana",
					"xlsx": "f37_a",
					"html": "f37_a"
				},
				{
					"nombre": "Resultados de los Mecanismos de Participación Ciudadana",
					"xlsx": "f37_b",
					"html": "f37_b"
				}
			]
		},
		{
			"nombre": "38.- Programas Ofrecidos",
			"icono":"ProgramasOfrecidos.png",
			"url":"https://s-salud.hidalgo.gob.mx/Transparencia/RubrosSsh/DetalleRubroSsh/38.%20Programas%20Ofrecidos",
			"formatos": [
				{
					"nombre": "Programas que Ofrecen",
					"xlsx": "f38_a",
					"html": "f38_a",
					"xlsx_liga" : "https://s-salud.hidalgo.gob.mx/contenido/transparencia/48RubrosSSH/xlsx/2022/a69_f38_aSSH.xlsx",
					"htm_liga" : "https://s-salud.hidalgo.gob.mx/contenido/transparencia/48RubrosSSH/htm/2022/a69_f38_aSSH.htm"
				},
				{
					"nombre": "Tramites a los Programas que Ofrecen",
					"xlsx": "f38_b",
					"html": "f38_b",
					"xlsx_liga" : "https://s-salud.hidalgo.gob.mx/contenido/transparencia/48RubrosSSH/xlsx/2022/a69_f38_bSSH.xlsx",
					"htm_liga" : "https://s-salud.hidalgo.gob.mx/contenido/transparencia/48RubrosSSH/htm/2022/a69_f38_bSSH.htm"
				}
			]
		},
		{
			"nombre": "39.- Actas y Resoluciones del Comité de Transparencia",
			"icono":"ActasResolucionesComiteTransparencia.png",
			"url" : "https://s-contraloria.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/39.%20Actas%20y%20Resoluciones%20del%20Comit%C3%A9%20de%20Transparencia",
			"formatos": [
				{
					"nombre": "Informe de Sesiones",
					"xlsx": "f39_a",
					"html": "f39_a",
					"xlsx_liga" : "https://s-contraloria.hidalgo.gob.mx/transparencia/xls/a69_f39a_SC.xlsx",
					"htm_liga" : "https://s-contraloria.hidalgo.gob.mx/transparencia/htm/a69_f39a_SC.htm"
				},
				{
					"nombre": "Informe de Resoluciones",
					"xlsx": "f39_b",
					"html": "f39_b",
					"xlsx_liga" : "https://s-contraloria.hidalgo.gob.mx/transparencia/xls/a69_f39b_SC.xlsx",
					"htm_liga" : "https://s-contraloria.hidalgo.gob.mx/transparencia/htm/a69_f39b_SC.htm"
				},
				{
					"nombre": "Actas Integrantes del Comité",
					"xlsx": "f39_c",
					"html": "f39_c",
					"xlsx_liga" : "https://s-contraloria.hidalgo.gob.mx/transparencia/xls/2022/CuartoTrimestre/a69_f39c_SC.xlsx",
					"htm_liga" : "https://s-contraloria.hidalgo.gob.mx/transparencia/htm/a69_f39c_SC_archivos/a69_f39c_SC.htm"
				},
				{
					"nombre": "Calendario de Sesiones del comité",
					"xlsx": "f39_d",
					"html": "f39_d",
					"xlsx_liga" : "https://s-contraloria.hidalgo.gob.mx/transparencia/xls/2022/CuartoTrimestre/a69_f39d_SC.xlsx",
					"htm_liga" : "https://s-contraloria.hidalgo.gob.mx/transparencia/htm/a69_f39d_archivos/a69_f39d_SC.htm"
				}
			]
		},
		{
			"nombre": "40.- Evaluacion y Encuesta a Programas Financiados con Recursos Públicos",
			"icono":"EvaluacionencuestasProgramas.png",
			"url" : "https://hacienda.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/40.Evaluacion%20y%20Encuestas%20a%20Programas%20Financiados%20con%20Recursos%20P%C3%BAblicos",
			"formatos": [
				{
					"nombre": "Evaluaciones",
					"xlsx": "f40_a",
					"html": "f40_a",
					"xlsx_liga" : "https://s-finanzas.hidalgo.gob.mx/transparencia/xlsx/2023/Primer%20Trimestre/a69_f40_aSFP.xlsx",
					"htm_liga" : "https://s-finanzas.hidalgo.gob.mx/transparencia/htm/2023/Primer%20Trimestre/a69_f40_aSFP.htm"
				},
				{
					"nombre": "Encuestas",
					"xlsx": "f40_b",
					"html": "f40_b",
					"xlsx_liga" : "https://s-finanzas.hidalgo.gob.mx/transparencia/xlsx/2023/Primer%20Trimestre/a69_f40_bSFP.xlsx",
					"htm_liga" : "https://s-finanzas.hidalgo.gob.mx/transparencia/htm/2023/Primer%20Trimestre/a69_f40_bSFP.htm"
				}
			]	
		},
		{
			"nombre": "41.- Estudios Pagados con Recursos Públicos",
			"icono":"EstudiosPagadosRecursosPublicos.png",
			"formatos": [
				{
					"nombre": "Estudios Pagados con Recursos Públicos ",
					"xlsx": "f41",
					"html": "f41"
				}
			]
			
		},
		{
			"nombre": "42.- Listados Jubilados y Pensionados",
			"icono":"ListadoJubiladosPencionados.png",
			"url" : "https://oficialiamayor.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/42.%20Listados%20Jubilados%20y%20Pensionados",
			"formatos": [
				{
					"nombre": "Jubilados y Pensionados Leyenda",
					"xlsx": "f42_a",
					"html": "f42_a",
					"xlsx_liga" : "https://oficialiamayor.hidalgo.gob.mx/transparencia/xlsx/2023/a69_f42_aOM.xlsx",
					"htm_liga" : "https://oficialiamayor.hidalgo.gob.mx/transparencia/htm/2023/a69_f42_aOM.htm"
				},
				{
					"nombre": "Jubilados y Pensionados Listado",
					"xlsx": "f42_b",
					"html": "f42_b",
					"xlsx_liga" : "https://oficialiamayor.hidalgo.gob.mx/transparencia/xlsx/2023/a69_f42_bOM.xlsx",
					"htm_liga" : "https://oficialiamayor.hidalgo.gob.mx/transparencia/htm/2023/a69_f42_bOM.htm"
				}
			]	
			
		},
		{
			"nombre": "43.- Ingresos Recibidos por Cualquier Concepto",
			"icono":"IngresosRecibidosCualquierConcepto.png",
			"url" : "https://hacienda.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/43.Ingresos%20Recibidos%20por%20Cualquier%20Concepto",
			"formatos": [
				{
					"nombre": "Ingresos Recibidos",
					"xlsx": "f43_a",
					"html": "f43_a",
					"xslx_liga" : "https://s-finanzas.hidalgo.gob.mx/transparencia/xlsx/2023/Primer%20Trimestre/a69_f43_aSFP.xlsx",
					"htm_liga" : "https://s-finanzas.hidalgo.gob.mx/transparencia/htm/2023/Primer%20Trimestre/a69_f43_aSFP.htm"
				},
				{
					"nombre": "Responsables de Recibir los Ingresos",
					"xlsx": "f43_b",
					"html": "f43_b",
					"xslx_liga" : "https://s-finanzas.hidalgo.gob.mx/transparencia/xlsx/2023/Primer%20Trimestre/a69_f43_bSFP.xlsx",
					"htm_liga" : "https://s-finanzas.hidalgo.gob.mx/transparencia/htm/2023/Primer%20Trimestre/a69_f43_bSFP.htm"
				}
			]	
			
		},
		{
			"nombre": "44.- Donaciones en dinero y en especie realizadas",
			"icono":"DonacionesHechasTerceros.png",
			"formatos": [
				{
					"nombre": "Donaciones en dinero y en especie realizadas",
					"xlsx": "f44",
					"html": "f44"
				},
			]	
			
		},
		{
			"nombre": "45.- Catálogo Documental y Guia de Archivos",
			"icono":"Viaticos.png",
			"formatos": [
				{
					"nombre": "Inventarios Documentales",
					"xlsx": "f45_a",
					"html": "f45_a",
					//"xslx_liga" : "https://s-contraloria.hidalgo.gob.mx/transparencia/xls/a69_f45_SC.xlsx",
					//"htm_liga" : "https://s-contraloria.hidalgo.gob.mx/transparencia/htm/a69_f45_SC.htm"
				},{
					"nombre": "Índice de expedientes clasificados",
					//"xlsx": "f45_b",
					//"html": "f45_b",
					"xlsx_liga" : "https://s-contraloria.hidalgo.gob.mx/Transparencia/xlsx/a69_f45b_SC.xlsx",
					"htm_liga" : "https://s-contraloria.hidalgo.gob.mx/Transparencia/htm/a69_f45b_SC.htm"
				},{
					"nombre": "Instrumentos Archivisticos",
					"xlsx": "f45_c",
					"html": "f45_c",
					//"xlsx_liga" : "https://oficialiamayor.hidalgo.gob.mx/Transparencia/xlsx/45c-LGT_Art_70_Fr_XLVOM.xlsx",
					//"htm_liga" : "https://oficialiamayor.hidalgo.gob.mx/Transparencia/htm/45c-LGT_Art_70_Fr_XLVOM.htm"
				}
			]
			
		},
		{
			"nombre": "46.- Actas de Sesiones, Opiniones y Recomendaciones de Consejos Consultivos",
			"icono":"CatalogoDocumentalGuiaArchivos.png",
			"url" : "https://s-turismo.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/46.Actas%20de%20Sesiones,%20Opiniones%20y%20Recomendaciones%20de%20Consejos%20Consultivos",
			"formatos": [
				{
					"nombre": "Actas del Consejo Consultivo Ciudadano",
					"xlsx": "f46_a",
					"html": "f46_a",
					"xlsx_liga" : "https://s-turismo.hidalgo.gob.mx/transparencia/xlsx/a69_f46_a_SECTURH.xlsx",
					"htm_liga" : "https://s-turismo.hidalgo.gob.mx/transparencia/htm/a69_f46_a_SECTURH.htm"
				},
				{
					"nombre": "Opiniones del Consejo Consultivo Ciudadano",
					"xlsx": "f46_b",
					"html": "f46_b",
					"xlsx_liga" : "https://s-turismo.hidalgo.gob.mx/transparencia/xlsx/a69_f46_b_SECTURH.xlsx",
					"htm_liga" : "https://s-turismo.hidalgo.gob.mx/transparencia/htm/a69_f46_b_SECTURH.htm"
				}
			]	
		},
		{
			"nombre": "47.- Solicitud de Intervecion de  Comunicaciones",
			"icono":"SolicitudIntervencionComunicaciones.png",
			"url" : "https://procuraduria.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/Solicitud%20de%20Intervecion%20de%20%20Comunicaciones",
			"formatos": [
				{
					"nombre": "Intervenciones de comunicaciones",
					"xlsx": "f47_a",
					"html": "f47_a",
					"xlsx_liga" : "https://procuraduria.hidalgo.gob.mx/transparencia/xlsx/2023/a69_f47_aPGJEH.xlsx",
					"htm_liga" : "https://procuraduria.hidalgo.gob.mx/transparencia/htm/a69_f47_aPGJEH.htm"
				},
				{
					"nombre": "Localización Geográfica",
					"xlsx": "f47_b",
					"html": "f47_b",
					"xlsx_liga" : "https://procuraduria.hidalgo.gob.mx/transparencia/xlsx/2023/a69_f47_bPGJEH.xlsx",
					"htm_liga" : "https://procuraduria.hidalgo.gob.mx/transparencia/htm/a69_f47_bPGJEH.htm"
				},
				{
					"nombre": "Mensaje de Solicitudes a empresas para la intervención de comunicaciones privadas",
					"xlsx": "f47_c",
					"html": "f47_c",
					"xlsx_liga" : "https://procuraduria.hidalgo.gob.mx/transparencia/xlsx/2023/a69_f47_cPGJEH.xlsx",
					"htm_liga" : "https://procuraduria.hidalgo.gob.mx/transparencia/htm/a69_f47_cPGJEH.htm"
				}
			]
		}
		,
		{
			"nombre": "48.- Información de Utilidad o Relevante",
			"icono":"InformacionUtilidadRelevante.png",
			"formatos": [
				{
					"nombre": "Interés Público",
					"xlsx": "f48_a",
					"html": "f48_a"
				},
				{
					"nombre": "Preguntas Frecuentes",
					"xlsx": "f48_b",
					"html": "f48_b"
				},
				{
					"nombre": "Transparencia Proactiva",
					"xlsx": "f48_c",
					"html": "f48_c"
				}
			]
		},
]